<template>
<v-app id="inspire">
  <user-change-password :changePasswordDialog="changePasswordDialog" v-on:close-dialog="changePasswordDialog=false" v-on:change-password="showResults" />
  <ui-notification
      :error="snackError"
      :message="snackMessage"
      :showSnack="snackShow"
      v-on:close-snack="snackShow=false"
     />
  <v-navigation-drawer fixed v-model="drawer" app clipped>
    <v-toolbar flat dark class="blue-grey">
      <v-list class="pa-0">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon>account_box</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title dark class="font-weight-bold">Hola {{userFullName}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-toolbar>

    <v-list>
      <v-list-tile v-for="link in links" :key="link.text" router :to="link.route">
        <v-list-tile-action>
          <v-icon>{{link.icon}}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{link.text}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile key="salir" @click="logout">
        <v-list-tile-action>
          <v-icon>exit_to_app</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Salir</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>

  </v-navigation-drawer>

  <v-toolbar color="blue-grey" dark fixed app clipped-left>
    <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
    <v-toolbar-title>CatDaf</v-toolbar-title>
    <v-spacer></v-spacer>
    
    <div v-if="historicDate">
        <span>Precios del: {{historicDate | formatDateTime}}</span>
    </div>

    <v-badge color="red" overlap v-if="hasActivePurcharseOrder">
        <span slot="badge" v-if="hasDetails">{{detailsLength}}</span>
        <v-btn icon><v-icon>shopping_cart</v-icon></v-btn>
    </v-badge>

    <v-menu :nudge-width="100" bottom left v-if="showList">
      <v-toolbar-title slot="activator">
        <v-icon :color="currentList.color" dark>more_vert</v-icon>
      </v-toolbar-title>

      <v-list>
        <v-list-tile v-for="list in priceLists" :key="list.id" @click="setSelectedPriceList(list.id)" active-class="v-list__tile--active" :class="list.id === currentList.id ? 'v-list__tile--active blue--text' : ''">
          {{list.name}}
        </v-list-tile>
      </v-list>
    </v-menu>

    <v-menu :nudge-width="100" bottom left>
      <v-toolbar-title slot="activator">
        <v-icon dark>settings</v-icon>
      </v-toolbar-title>

      <v-list>
        <v-list-tile key="change-password" active-class="v-list__tile--active" @click.stop="changePasswordDialog = true">
          Cambiar Contraseña
        </v-list-tile>
        <v-list-tile key="search-updates" active-class="v-list__tile--active" @click.stop="refreshSite">
          Buscar actualizaciones
        </v-list-tile>
      </v-list>
    </v-menu>

  </v-toolbar>
  <v-content :class="{
        'ma-0': $vuetify.breakpoint.smAndDown,
        'ma-4': $vuetify.breakpoint.mdAndUp}">
    <router-view
      v-on:error="showError"
      v-on:success="showSuccess"
     />
  </v-content>

  <v-footer color="blue-grey" class="white--text px-4 " app>
    <div>CatDaf</div>
    <v-spacer></v-spacer>
    <div>&copy; 2023</div>
    <div>&nbsp; v{{ productVersion }} </div>
  </v-footer>
</v-app>
</template>

<script>
import _ from 'underscore';
import {
  AUTH_LOGOUT,
} from '../../store/actions/auth';
import {
  USER_SELECT_LIST,
} from '../../store/actions/user';
import {
  CLEAR_PRODUCT_STORE,
} from '../../store/actions/product';
import {
  CLEAR_PURCHARSE_ORDER_STORE,
} from '../../store/actions/purcharseOrder';


export default {
  name: 'Layout',
  data: () => ({
    drawer: false,
    left: null,
    show: true,
    changePasswordDialog: false,
    // Snack data
    snackShow: false,
    snackError: false,
    snackMessage: '',
  }),
  computed: {
    userFullName() {
      return this.$store.state.user.profile.name;
    },
    links() {
      return this.$store.state.user.profile.links;
    },
    priceLists() {
      return this.$store.getters.getProfile.priceLists;
    },
    showList() {
      return this.$store.state.user.profile.showList;
    },
    currentList() {
      return this.$store.state.user.profile.currentList;
    },
    historicDate() {
      return this.$store.state.user.profile.historicDate;
    },
    activeRoute() {
      return this.$store.state.route.currentRoute;
    },
    hasActivePurcharseOrder() {
      return this.$store.getters.hasActivePurcharseOrder;
    },
    hasDetails() {
      return !_.isEmpty(this.$store.state.purcharseOrder.purcharseOrder.details);
    },
    detailsLength() {
      return this.$store.state.purcharseOrder.purcharseOrder.details.length;
    },
    productVersion() {
      return JSON.parse(unescape(process.env.PACKAGE_JSON || '%7Bversion%3A0%7D')).version;
    },
  },
  methods: {
    logout() {
      const that = this;
      this.$store.dispatch(AUTH_LOGOUT, {})
        .then(async () => {
          await this.$store.dispatch(CLEAR_PRODUCT_STORE);
          await this.$store.dispatch(CLEAR_PURCHARSE_ORDER_STORE);
          that.$router.push('/login');
        });
    },
    setSelectedPriceList(id) {
      const selectedList = this.priceLists.filter((e) => e.id === id)[0];
      this.$store.dispatch(USER_SELECT_LIST, selectedList);
      // Send to the backend ?
    },
    showResults(event, data) {
      if (event.status === 200) {
        this.showSuccess('Cambio de contraseña correcto');
      } else {
        this.showError('Ocurrio un error al actualizar la contraseña');
      }
    },
    showError(message) {
      this.snackShow = true;
      this.snackError = true;
      if (message === 'Network Error' || message.message === 'Network Error') {
        message = 'Error de conexión, revise su conexión a internet';
      }
      this.snackMessage = message;
    },
    showSuccess(message) {
      this.snackShow = true;
      this.snackError = false;
      this.snackMessage = message;
    },
    refreshSite() {
      location.reload(true); // force reload.
    },
  },
};
</script>
